import { isTotalRowClassName } from './isTotalRowClassName';

type StripeExemptCell = {
  largeHeader?: boolean;
  isLegend?: boolean;
  isTotal?: boolean | null;
  className?: string | null;
};

export const isStripeExemptCell = (cell: StripeExemptCell | null | undefined): boolean => {
  if (!cell) {
    return false;
  }

  // These cell roles already carry emphasis; alternating row color would flatten that hierarchy.
  if (cell.largeHeader || cell.isLegend || cell.isTotal) {
    return true;
  }

  const className = cell.className ?? '';

  // Column header rows are styled as headers, not as part of the data stripe pattern.
  if (className.includes('table-header')) {
    return true;
  }

  return isTotalRowClassName(className);
};
